import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { timer } from 'rxjs/observable/timer';
import { ActivatedRoute } from '@angular/router';
import { CANCELLED } from 'dns';

declare var $: any, moment: any

@Component({
  selector: 'app-depositor-info',
  templateUrl: './depositor-info.component.html',
  styleUrls: ['./depositor-info.component.scss']
})
export class DepositorInfoComponent implements OnInit {

  contactId = ""
  dpa_idcard = ""
  telephone1 = ""

  verifyOtp = ""

  contactType = ""

  ag: any = {}
  detail: any = {}
  status: any = {}

  isCrisis = true

  //role: any = {}
  cookieData: any

  contactDros: any = {}
  contact: any = {}
  agenBankList: any

  crm03: any = {}
  crm04: any = {}
  crm05: any = {}
  crm06: any = {}

  bankName = ""

  masterDocNames: any
  masterDocNamesCompany: any

  bankList: any
  
  lastReqTime: any
  disableResentOtp = false
  totolWaitResend = 59

  telephoneOtp = ""
  otp = ""
  otpRef = ""
  requestOtpLbl = "ส่ง"
  otpTimer: any = ""

  ElapseTime: number = 0;
  TotalTime: number = 0;
  OTPCountDown: string = "";
  SubScr: Subscription;

  constructor(
    private util: UtilService,
    private api: ApiService,
    private activatedRoute: ActivatedRoute
  ) { }

  async ngOnInit() {

    $('*[data-toggle="collapse"]').on("click", function () {
      if ($(this).hasClass("collapsed")) {
        const iconBtn = $(this).find(".fa-chevron-circle-down")[0]
        $(iconBtn).removeClass("fa-chevron-circle-down").addClass("fa-chevron-circle-up")
      }
      else {
        const iconBtn = $(this).find(".fa-chevron-circle-up")[0]
        $(iconBtn).removeClass("fa-chevron-circle-up").addClass("fa-chevron-circle-down")
      }
    });

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))

    let config: any = await this.api.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag == true) {
      this.cookieData.isCrisis = true
      localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))
    }
    else {
      this.cookieData.isCrisis = false
      localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))
    }
    this.isCrisis = this.cookieData.isCrisis

  }

  async init(contact: any) {
    this.util.ShowWaiting(true)
    //this.contact = contact;

    //this.contactId = contact.contactid;
    this.contactId = this.activatedRoute.snapshot.paramMap.get('id');
    this.contact = await this.getContact();
    
    // this.dpa_idcard = contact.dpa_idcard
    // this.telephone1 = contact.telephone1
    //this.contact.fullname = (contact.firstname == null ? "" : contact.firstname) + " " + (contact.lastname == null ? "" : contact.lastname)

    this.dpa_idcard = this.contact.dpa_idcard
    this.telephone1 = this.contact.telephone1
    this.contact.fullname = (this.contact.firstname == null ? "" : this.contact.firstname) + " " + (this.contact.lastname == null ? "" : this.contact.lastname)

    if (this.isCrisis) {
      await this.getDROS()
    }

    this.util.ShowWaiting(false)
  }

  callApi(): Observable<any> {
    return forkJoin([
      this.getDROS()
    ]);
  }

  async getContact() {
    let para = "contactid=" + this.contactId;
    let tmp: any = await this.api.get("crmservice", "contact", para);
    return tmp[0]
  }

  async getDROS() {
    let paraAgentBank = ""
    let para = "CRM03=true&CRM04=true&CRM05=true&CRM06=true&CRM07=true"
    if(this.contact.dpa_idcard != null && this.contact.dpa_idcard.trim().length > 0){
      para += "&dpa_id=" + this.contact.dpa_idcard
      paraAgentBank = "idcard=" + this.contact.dpa_idcard
    }
    else if(this.contact.dpa_passport != null && this.contact.dpa_passport.trim().length > 0){
      para += "&dpa_id=" + this.contact.dpa_passport
      paraAgentBank = "idcard=" + this.contact.dpa_passport
    }
    else if(this.contact.dpa_registrationid != null && this.contact.dpa_registrationid.trim().length > 0){
      para += "&dpa_id=" + this.contact.dpa_registrationid
      paraAgentBank = "idcard=" + this.contact.dpa_registrationid
    }

    if(this.telephone1 != null && this.telephone1.trim().length > 0){
      para += "&telephoneno=" + this.telephone1
    }

    //console.log(para);

    this.contactDros = await this.api.get("crmservice", "contactDros", para)
    
    this.agenBankList = await this.api.get("crmservice", "searchApprovalTicket", paraAgentBank)
    this.masterDocNames = await this.api.get("master", "personalType")
    this.masterDocNamesCompany = await this.api.get("master", "companyType")
    this.bankList = await this.api.get("master", "bank")
    if (this.contactDros.CRM07 != null && this.contactDros.CRM07.length > 0) {
      if (this.bankList == null || this.bankList.length == 0) {
        this.bankName = "ธนาคาร AAA"
      }
      else {
        let bankName: any = this.bankList.filter((mb: any) => {
          return mb.dpa_bankcode == this.contactDros.CRM07[0].BankCode
        })

        if (bankName != null && bankName.length > 0) {
          this.bankName = bankName[0].dpa_name
        }
        else{
          this.bankName = "ธนาคาร AAA"
        }
      }
    }
    else{
      this.bankName = "ธนาคาร AAA"
    }

    this.drawTableStatus()
    this.drawTableRefund()
    this.drawTableDetail()
    this.drawTableAgentBank()
  }

  close() {
    window.close()
  }

  getCrm03InCrm04(crm03: any) {
    if (this.contactDros.CRM04 == null) {
      return null
    }

    return this.contactDros.CRM04.filter((c: any) => {
      return c.RequestedNo == crm03.RequestedNo
    })
  }

  getCrm03InCrm05(crm03: any) {
    if (this.contactDros.CRM05 == null) {
      return null
    }

    return this.contactDros.CRM05.filter((c: any) => {
      return c.RequestedNo == crm03.RequestedNo
    })
  }

  drawTableStatus() {
    $("#tbStatus tbody").empty()
    try{
      $('#tbStatus').DataTable().clear().destroy();
    }
    catch(e){

    }
    try {

      //console.log(this.contactDros);

      if (this.contactDros != null && this.contactDros.CRM03 != null) { 
        let index = -1
        
        //let arr1 = this.contactDros.CRM03.map((obj: any) => { return { ...obj, date: new Date(obj.ModifyDate) }; });
        let arr1 = this.contactDros.CRM03;
        arr1.sort((firstObject: any, secondObject: any) => ( secondObject.RequestTypeCode  -  firstObject.RequestTypeCode
        ||   new Date(secondObject.ModifyDate.substring(0, 19)).getTime()  - new Date(firstObject.ModifyDate.substring(0, 19)).getTime() 
        ));
       // let sortedDesc = arr1.sort((objA: any, objB: any) => objB.date.getTime() - objA.date.getTime());
       arr1.forEach((c: any) => {
          index++
           
          let tr = ""

          tr += '<tr id="' + index + '">'
          tr += '<td>' + c.RequestedNo + '</td>'
          tr += '<td>' + c.RequestType + '</td>'
          tr += '<td>' + c.StatusDefinition + '</td>'
          tr += '<td>' + c.ProcessDefinition + '</td>'
         //tr += '<td>' + c.DisplayMessage + '</td>'
          tr += '<td>' + this.util.transformDate(c.ModifyDate, "shortWithTime")  + '</td>'
          tr += '</tr>'

          $("#tbStatus tbody").append(tr);
        });
      }
    }
    catch (e) {
      console.log('draw table status error')
    }

    let thisTs = this

    $("#tbStatus tbody tr").on("click", function () {

      thisTs.crm03 = {}
      thisTs.crm04 = {}
      thisTs.crm05 = {}

      thisTs.status = thisTs.contactDros.CRM03[parseInt($(this)[0].id)]

      let crm04List: any = thisTs.getCrm03InCrm04(thisTs.status)
      if (crm04List != null && crm04List.length > 0) {
        thisTs.crm04 = crm04List[0]
        thisTs.crm03 = thisTs.status

          if(thisTs.crm03.FilePath != null && thisTs.crm03.FilePath != null)
          {
            let para = thisTs.crm03.FilePath;
            var fields = para.split('/');
            var vfilename = fields[fields.length -1];
  
            thisTs.crm03.FileName = vfilename;
          }
          else
          {
            thisTs.crm03.FileName = "ไม่มีเอกสารเพิ่ม";
          }

        $("#crm04Modal").modal("show")
      }
      else {
        let crm05List: any = thisTs.getCrm03InCrm05(thisTs.status)
        if (crm05List != null && crm05List.length > 0) {
          thisTs.crm05 = crm05List[0]
          thisTs.crm03 = thisTs.status

          if(thisTs.crm03.FilePath != null && thisTs.crm03.FilePath != null)
          {
            let para = thisTs.crm03.FilePath;
            var fields = para.split('/');
            var vfilename = fields[fields.length -1];
  
            thisTs.crm03.FileName = vfilename;
          }
          else
          {
            thisTs.crm03.FileName = "ไม่มีเอกสารเพิ่ม";
          }
          $("#crm05Modal").modal("show")
        }
        else {
          thisTs.crm03 = thisTs.status

          if(thisTs.crm03.FilePath != null && thisTs.crm03.FilePath != null)
          {
            let para = thisTs.crm03.FilePath;
            var fields = para.split('/');
            var vfilename = fields[fields.length -1];
  
            thisTs.crm03.FileName = vfilename;
          }
          else
          {
            thisTs.crm03.FileName = "ไม่มีเอกสารเพิ่ม";
          }


          $("#statusModal").modal("show")
        }
      }
    });
    
    $("#tbStatus").dataTable({
      retrieve: true,
      'searching': false,
      'paginate': true,
      order: []
        });
  }

  drawTableRefund() {
    $("#tbRefund tbody").empty()
    try {
      if (this.contactDros != null && this.contactDros.CRM06 != null) {
        let tr = ""
        tr += '<tr>'
        tr += '<td>' + this.bankName + '</td>'
        tr += '<td>' + this.contactDros.CRM06.IDNo + '</td>'
        tr += '<td class="text-right">' + this.util.numberWithCommas(this.contactDros.CRM06.NetReimbursible) + '</td>'
        tr += '<td></td>'
        tr += '</tr>'

        $("#tbRefund tbody").append(tr);
      }
    }
    catch (e) {
      console.log('draw table refund error')
    }
    let thisTs = this

    $("#tbRefund tbody tr").on("click", function () {
      $("#financialModal").modal("show")
    });
    $("#tbRefund").dataTable({
      retrieve: true,
      'searching': false,
      'paginate': false
    });
  }

  drawTableDetail() {
    $("#tbDetail tbody").empty()
    try {
      if (this.contactDros != null && this.contactDros.CRM06 != null) {
        let tr = ""

        tr += '<tr>'
        tr += '<td>' + this.bankName + '</td>'
        tr += '<td>' + this.contactDros.CRM06.IDNo + '</td>'
        tr += '<td class="text-right">' + this.util.numberWithCommas(this.contactDros.CRM06.NetReimbursible) + '</td>'
        if(this.contactDros.CRM06.ModifyDate != null)
        {
          tr += '<td>' + this.util.transformDate(this.contactDros.CRM06.ModifyDate, "short") + '</td>'
        }
        else
        {
          
        tr += '<td>21 ต.ค. 2562</td>'
        }
        tr += '</tr>'

        $("#tbDetail tbody").append(tr);
      }
    }
    catch (e) {
      console.log('draw table detail error')
    }
    let thisTs = this

    $("#tbDetail tbody tr").on("click", function () {
      thisTs.crm06 = {}
      thisTs.crm06.PhoneNo = thisTs.contactDros.CRM06.PhoneNo
      thisTs.telephoneOtp = thisTs.contactDros.CRM06.PhoneNo
      thisTs.verifyOtp = ""
      $("#rebateModal").modal("show")
    });
    $("#tbDetail").dataTable({
      retrieve: true,
      'searching': false,
      'paginate': false
    });
  }

  drawTableAgentBank() {
    $("#tbAgentBank tbody").empty()
    let index = -1
    this.agenBankList.forEach((c: any) => {
      index++
      let tr = ""

      tr += '<tr id="' + index + '">'
      tr += '<td>' + (c.dpa_personaltypeidname || c.dpa_companytypeidname || '') + '</td>'
      tr += '<td>' + (c.dpa_idcard || c.dpa_passport || c.dpa_registrationid || '') + '</td>'
      tr += '<td>' + (c.dpa_name || '') + '</td>'
      tr += '<td>' + c.dpa_approvalstatusidname + '</td>'
      tr += '<td>' + this.util.transformDate(c.dpa_submitdate, "shortWithTime") + '</td>'
      tr += '</tr>'

      $("#tbAgentBank tbody").append(tr);
    });

    let thisTs = this

    $("#tbAgentBank tbody tr").on("click", function () {

      thisTs.ag = thisTs.agenBankList[parseInt($(this)[0].id)]
      

      thisTs.ag.dpa_submitdateFormated = thisTs.util.transformDate(thisTs.ag.dpa_submitdate, "shortWithTime")
      if(thisTs.ag.dpa_personaltypeid != null && thisTs.ag.dpa_personaltypeid.length > 0){
        thisTs.drawTableAgentBankDocList(thisTs.ag.dpa_personaltypeid, null)
      }
      else{
        thisTs.drawTableAgentBankDocList(null, thisTs.ag.dpa_companytypeid)
      }
      $("#agentBankModal").modal("show")

    });
    $("#tbAgentBank").dataTable({
      retrieve: true,
      'searching': false,
      'paginate': false
    });
  }

  drawTableAgentBankDocList(personalTypeId: string, companytypeid: string) {
    $("#tbDocList tbody").empty()
    let index = 0

    let docsList: any
    if(personalTypeId != null){
      docsList = this.masterDocNames.filter((p: any) => {
        return p.dpa_personaltypeid == personalTypeId
      })
    }
    else{
      docsList = this.masterDocNamesCompany.filter((p: any) => {
        return p.dpa_companytypeid == companytypeid
      })
    }

    if(docsList != null && docsList.length > 0){
      docsList[0].dpa_documentgrouplist.forEach((n: any) => {
        index++
          let tr = ""
  
          tr += '<tr>'
          tr += '<td>' + index.toString() + '</td>'
          tr += '<td>' + n.dpa_name + '</td>'
          tr += '</tr>'
  
          $("#tbDocList tbody").append(tr);
      });
    }

    $("#tbDocList").dataTable({
      retrieve: true,
      'searching': false,
      'paginate': true
    });
  }

  async verify() {
    if (this.verifyOtp.trim().length > 0) {

      let reqCheckOtp: any = {
        OTP: this.verifyOtp.trim(),
        RefCode: this.otpRef,
        MobileNo: this.telephoneOtp
      }

      let reqCheckOtpRes: any = await this.api.postCustom("crm", "VerifyOTP", reqCheckOtp)
      if (this.util.isSuccessResponse(reqCheckOtpRes)) {
        if (reqCheckOtpRes.IsValid) {
          this.crm06 = this.contactDros.CRM06
          //this.crm06.fullname = this.contact.fullname
          this.crm06.bankname = this.bankName
        }
        else {
          this.util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง")
        }
      }
      else {
        this.util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่")
      }
    }
    else{
      this.util.WarningDialog("กรุณากรอกรหัส OTP")
    }
  }

  getDocMasterName(id: string) {
    let name = ""
    this.masterDocNames.forEach((m: any) => {
      m.dpa_documentgrouplist.forEach((g: any) => {
        for(let i = 0; i < g.dpa_documentlist.length; i++){
          if (g.dpa_documentlist[i].dpa_documentid == id) {
            name = g.dpa_documentlist[i].dpa_name
            break;
          }
        }
      });
    });
    return name
  }

  async requestOtp() {
    let reqOtp: any = {
      MobileNo: this.telephoneOtp,
    }

    await this.api.postCustom("crm", "RequestOTP", reqOtp).then(async (reqOtpRes: any) => {
      if (this.util.isSuccessResponse(reqOtpRes)) {

        let smsContent = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : "
        smsContent += reqOtpRes.otpNo + " "
        smsContent += "(RefCode : " +reqOtpRes.RefCode  
        smsContent += ") (รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น"   


        let sendSms: any = {
          dpa_description: smsContent,
          dpa_phoneno: this.telephoneOtp
        }
        let sendSmsRes: any = await this.api.post("crmservice", "sendSms", sendSms)

        if (this.util.isSuccessResponse(sendSmsRes)) {
          this.otpRef = reqOtpRes.RefCode
          this.otpTimer = 59
          this.lastReqTime = new Date()
          this.requestOtpLbl = "ส่งอีกครั้ง"
          this.disableResentOtp = true
          this.countdown()
          if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
            this.TotalTime = 300;
          }
          else {
            this.TotalTime = reqOtpRes.expInMinute * 60;
          }
          this.ElapseTime = 0;
          if (this.SubScr != undefined) {
            this.SubScr.unsubscribe();
          }
          this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
        }
        else {
          this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
        }
      }
      else {
        this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
      }
    })
  }

  countdown() {
    if (this.otpTimer > 0) {

      let dif = new Date().getTime() - this.lastReqTime.getTime();

      var Seconds_from_T1_to_T2 = dif / 1000;
      this.otpTimer = this.totolWaitResend  - Math.round(Seconds_from_T1_to_T2)
      setTimeout(() => {
        this.countdown()
      }, 400);
    }
    else {
      this.disableResentOtp = false
    }
  }

  CountDownOTP() {
    if (this.ElapseTime == 0 && this.TotalTime == 0) {
      this.SubScr.unsubscribe();
      this.OTPCountDown = "";
      return;
    }
    if (this.ElapseTime == this.TotalTime) {
      this.SubScr.unsubscribe();
      this.ElapseTime = 0;
      this.OTPCountDown = "";
      return;
    }

    this.ElapseTime++;
    let RemainingSecs = this.TotalTime - this.ElapseTime;
    let RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
    RemainingSecs = RemainingSecs % 60;
    this.OTPCountDown = " " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs;
  }

  // get03File(vfilename: any)
  // {
    
  // }

  async showPdf() {

    if(this.crm03.FilePath != null && this.crm03.FilePath != "")
    {
      console.log(this.crm03.FilePath);
      
      let para = "FilePath=" + this.crm03.FilePath;
      let tmp: any = await this.api.get("crmservice", "getFileDROS2", para);
      let fileName: any = this.crm03.FilePath.split('/');
      var vfilename = fileName[fileName.length -1]; 
      const linkSource = tmp.File;

     /* var objbuilder = '';
      objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
      objbuilder += (linkSource);
      objbuilder += ('" type="application/pdf" class="internal">');
      objbuilder += ('<embed src="data:application/pdf;base64,');
      objbuilder += (linkSource);
      objbuilder += ('" type="application/pdf"  />');
      objbuilder += ('</object>');

      var win = window.open("#","_blank");
      var title = "my tab title";
      win.document.write('<html><title>'+ vfilename +'</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
      win.document.write(objbuilder);
      win.document.write('</body></html>');
 
     /*objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
      objbuilder += (linkSource);
      objbuilder += ('" type="application/pdf" class="internal">');
      objbuilder += ('<embed src="data:application/pdf;base64,');
      objbuilder += (linkSource);
      objbuilder += ('" type="application/pdf"  />');
      objbuilder += ('</object>');
  
      var win = window.open("#","_blank");
      var title = "my tab title";
      win.document.write('<html><title>'+ title +'</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
      win.document.write(objbuilder);
      win.document.write('</body></html>');  
  
  
      var objbuilder2 = '';
      const linkSource2 = encodeURI(tmp.File);
      console.log(tmp.size)
      objbuilder2 += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
      objbuilder2 += (linkSource2);
      objbuilder2 += ('" type="application/pdf" class="internal">');
      objbuilder2 += ('<embed src="data:application/pdf;base64,');
      objbuilder2 += (linkSource2);
      objbuilder2 += ('" type="application/pdf"  />');
      objbuilder2 += ('</object>');
  
      var win3 = window.open("#","_blank");
      var title3 = "my tab title3";
      win3.document.write('<html><title>'+ title3 +'</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
      win3.document.write(objbuilder2);
      win3.document.write('</body></html>');  */
  
      const win2 = window.open("","_blank");
      let html = '';
  
      html += '<html><head><title>' + vfilename + '</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>' ;
      html += '<body style="margin:0!important">';
      html += '<embed width="100%" height="100%" src="data:application/pdf;base64,'+encodeURI(linkSource)+'" type="application/pdf" />';
      html += '</body>';
      html += '</html>'; 
      
      setTimeout(() => {
            win2.document.write(html);
          }, 0);
          
    }


    //const linkSource = 'data:application/pdf;base64,' + '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\n';
    // const downloadLink = document.createElement("a");
    // const fileName = "sample.pdf";

    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();
}
}



// WEBPACK FOOTER //
// ./src/app/depositor-info/depositor-info.component.ts